/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function OutOfDate({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M8 .4c1.82 0 3.222.532 4.46 1.572a.53.53 0 0 1-.067.861.6.6 0 0 1-.654-.026A6.4 6.4 0 1 0 8 14.4c1.397 0 2.038-.755 2.492-.164.308.402-.014.965-.502 1.098A7.6 7.6 0 1 1 8 .4m5.9 12.55a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8m0-7.95a.6.6 0 0 1 .6.6v5.3a.6.6 0 0 1-1.2 0V5.6a.6.6 0 0 1 .6-.6M8 3.4a.6.6 0 0 1 .6.6v3.719l1.87 1.558a.71.71 0 0 1 .256.554c-.008.537-.58.846-1 .512C8.919 9.697 8.155 8.909 7.4 8.28V4a.6.6 0 0 1 .6-.6" /></svg>;
}
;